function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { scrollWithAnimation, Easing } from './animate.js';

var install = function install(Vue, options) {
  if (install.installed) return;
  var bodyScrollEl = {}; // For ff, ie

  Object.defineProperty(bodyScrollEl, 'scrollTop', {
    get: function get() {
      return document.body.scrollTop || document.documentElement.scrollTop;
    },
    set: function set(val) {
      document.body.scrollTop = val;
      document.documentElement.scrollTop = val;
    }
  });
  Object.defineProperty(bodyScrollEl, 'scrollHeight', {
    get: function get() {
      return document.body.scrollHeight || document.documentElement.scrollHeight;
    }
  });
  Object.defineProperty(bodyScrollEl, 'offsetHeight', {
    get: function get() {
      return window.innerHeight;
    }
  });
  var scrollSpyContext = '@@scrollSpyContext';
  var scrollSpyElements = {};
  var scrollSpySections = {};
  var activeElement = {};
  var activableElements = {};
  var currentIndex = {};
  options = Object.assign({
    allowNoActive: false,
    sectionSelector: null,
    data: null,
    offset: 0,
    time: 500,
    steps: 30,
    easing: null,
    active: {
      selector: null,
      "class": 'active'
    },
    link: {
      selector: 'a'
    }
  }, options || {});

  function findElements(container, selector) {
    if (!selector) {
      return container.children;
    }

    var id = scrollSpyId(container);
    var elements = [];

    var _iterator = _createForOfIteratorHelper(container.querySelectorAll(selector)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var el = _step.value;

        // Filter out elements that are owned by another directive
        if (scrollSpyIdFromAncestors(el) === id) {
          elements.push(el);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return elements;
  }

  function scrollSpyId(el) {
    return el.getAttribute('data-scroll-spy-id') || el.getAttribute('scroll-spy-id') || 'default';
  }

  function scrollSpyIdDefined(el) {
    return !!el.getAttribute('data-scroll-spy-id') || !!el.getAttribute('scroll-spy-id');
  }

  function scrollSpyIdFromAncestors(el) {
    do {
      if (scrollSpyIdDefined(el)) {
        return scrollSpyId(el);
      }

      el = el.parentElement;
    } while (el);

    return 'default';
  }

  function initScrollSections(el, sectionSelector) {
    var id = scrollSpyId(el);
    var scrollSpyContextEl = el[scrollSpyContext];
    var idScrollSections = findElements(el, sectionSelector);
    scrollSpySections[id] = idScrollSections;

    if (idScrollSections[0] && idScrollSections[0].offsetParent !== el) {
      scrollSpyContextEl.eventEl = window;
      scrollSpyContextEl.scrollEl = bodyScrollEl;
    }
  }

  function getOffsetTop(elem, untilParent) {
    var offsetTop = 0;

    do {
      if (!isNaN(elem.offsetTop)) {
        offsetTop += elem.offsetTop;
      }

      elem = elem.offsetParent;
    } while (elem && elem !== untilParent);

    return offsetTop;
  }

  function scrollTo(el, index) {
    var id = scrollSpyId(el);
    var idScrollSections = scrollSpySections[id];
    var _el$scrollSpyContext = el[scrollSpyContext],
        scrollEl = _el$scrollSpyContext.scrollEl,
        options = _el$scrollSpyContext.options;
    var current = scrollEl.scrollTop;

    if (idScrollSections[index]) {
      var target = getOffsetTop(idScrollSections[index]) - options.offset;

      if (options.easing) {
        scrollWithAnimation(scrollEl, current, target, options.time, options.easing);
        return;
      }

      var time = options.time;
      var steps = options.steps;
      var timems = parseInt(time / steps);
      var gap = target - current;

      var _loop = function _loop(i) {
        var pos = current + gap / steps * i;
        setTimeout(function () {
          scrollEl.scrollTop = pos;
        }, timems * i);
      };

      for (var i = 0; i <= steps; i++) {
        _loop(i);
      }
    }
  }

  Vue.directive('scroll-spy', {
    bind: function bind(el, binding, vnode) {
      function onScroll() {
        var id = scrollSpyId(el);
        var idScrollSections = scrollSpySections[id];
        var _el$scrollSpyContext2 = el[scrollSpyContext],
            scrollEl = _el$scrollSpyContext2.scrollEl,
            options = _el$scrollSpyContext2.options;
        var index;

        if (scrollEl.offsetHeight + scrollEl.scrollTop >= scrollEl.scrollHeight - 10) {
          index = idScrollSections.length;
        } else {
          for (index = 0; index < idScrollSections.length; index++) {
            if (getOffsetTop(idScrollSections[index], scrollEl) - options.offset > scrollEl.scrollTop) {
              break;
            }
          }
        }

        index = index - 1;

        if (index < 0) {
          index = options.allowNoActive ? null : 0;
        } else if (options.allowNoActive && index >= idScrollSections.length - 1 && getOffsetTop(idScrollSections[index]) + idScrollSections[index].offsetHeight < scrollEl.scrollTop) {
          index = null;
        }

        if (index !== currentIndex[id]) {
          var idActiveElement = activeElement[id];

          if (idActiveElement) {
            idActiveElement.classList.remove(idActiveElement[scrollSpyContext].options["class"]);
            activeElement[id] = null;
          }

          currentIndex[id] = index;

          if (typeof currentIndex !== 'undefined' && Object.keys(activableElements).length > 0) {
            idActiveElement = activableElements[id][currentIndex[id]];
            activeElement[id] = idActiveElement;

            if (idActiveElement) {
              idActiveElement.classList.add(idActiveElement[scrollSpyContext].options["class"]);
            }
          }

          if (options.data) {
            Vue.set(vnode.context, options.data, index);
          }
        }
      }

      vnode.context.$scrollTo = scrollTo.bind(null, el);
      var id = scrollSpyId(el);
      el[scrollSpyContext] = {
        onScroll: onScroll,
        options: Object.assign({}, options, binding.value),
        id: scrollSpyId(el),
        eventEl: el,
        scrollEl: el
      };
      scrollSpyElements[id] = el;
      delete currentIndex[id];
    },
    inserted: function inserted(el) {
      var sectionSelector = el[scrollSpyContext].options.sectionSelector;
      initScrollSections(el, sectionSelector);
      var _el$scrollSpyContext3 = el[scrollSpyContext],
          eventEl = _el$scrollSpyContext3.eventEl,
          onScroll = _el$scrollSpyContext3.onScroll;
      eventEl.addEventListener('scroll', onScroll);
      onScroll();
    },
    componentUpdated: function componentUpdated(el, binding) {
      el[scrollSpyContext].options = Object.assign({}, options, binding.value);
      var _el$scrollSpyContext4 = el[scrollSpyContext],
          onScroll = _el$scrollSpyContext4.onScroll,
          sectionSelector = _el$scrollSpyContext4.options.sectionSelector;
      initScrollSections(el, sectionSelector);
      onScroll();
    },
    unbind: function unbind(el) {
      var _el$scrollSpyContext5 = el[scrollSpyContext],
          eventEl = _el$scrollSpyContext5.eventEl,
          onScroll = _el$scrollSpyContext5.onScroll;
      eventEl.removeEventListener('scroll', onScroll);
    }
  });

  function scrollSpyActive(el, binding) {
    var activeOptions = Object.assign({}, options.active, binding.value);
    initScrollActiveElement(el, activeOptions);
  }

  function initScrollActiveElement(el, activeOptions) {
    var id = scrollSpyId(el);
    activableElements[id] = findElements(el, activeOptions.selector);

    var arr = _toConsumableArray(activableElements[id]);

    arr.map(function (el) {
      el[scrollSpyContext] = {
        options: activeOptions
      };
    });
  }

  Vue.directive('scroll-spy-active', {
    inserted: scrollSpyActive,
    componentUpdated: scrollSpyActive
  });

  function scrollLinkClickHandler(index, scrollSpyId, event) {
    scrollTo(scrollSpyElements[scrollSpyId], index);
  }

  function initScrollLink(el, selector) {
    var id = scrollSpyId(el);
    var linkElements = findElements(el, selector);

    for (var i = 0; i < linkElements.length; i++) {
      var linkElement = linkElements[i];
      var listener = scrollLinkClickHandler.bind(null, i, id);

      if (!linkElement[scrollSpyContext]) {
        linkElement[scrollSpyContext] = {};
      }

      if (!linkElement[scrollSpyContext].click) {
        linkElement.addEventListener('click', listener);
        linkElement[scrollSpyContext].click = listener;
      }
    }
  }

  Vue.directive('scroll-spy-link', {
    inserted: function inserted(el, binding) {
      var linkOptions = Object.assign({}, options.link, binding.value);
      initScrollLink(el, linkOptions.selector);
    },
    componentUpdated: function componentUpdated(el, binding) {
      var linkOptions = Object.assign({}, options.link, binding.value);
      initScrollLink(el, linkOptions.selector);
    },
    unbind: function unbind(el) {
      var linkElements = findElements(el);

      for (var i = 0; i < linkElements.length; i++) {
        var linkElement = linkElements[i];
        var id = scrollSpyId(el);
        var listener = scrollLinkClickHandler.bind(null, i, id);

        if (!linkElement[scrollSpyContext]) {
          linkElement[scrollSpyContext] = {};
        }

        if (linkElement[scrollSpyContext].click) {
          linkElement.removeEventListener('click', listener);
          delete linkElement[scrollSpyContext]['click'];
        }
      }
    }
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

;
export default install;
export { Easing, install };